import { useEffect, useState } from "react";
import { UserTabs } from "./UserTabs";
import { Deposit } from "../../deposit/components/Deposit";
import UserProfilePage from "../components/profile/UserProfile";
import Transactions from "../../transaction/components/Transactions";
import { useLocation, useNavigate } from "react-router-dom";
import { ResponsibleGaming } from "../../responsible-gaming/components/ResponsibleGaming";
import { Verification } from "../../verification/components/verification";
import Withdraw from "../../withdraw/components/Withdraw";
import InboxList from "../../inbox/components/Inbox";
import { WalletHistory } from "../../wallethistory/components/WalletHistory";
import Bonus from "../../bonus/components/Bonus";
import { deviceService } from "../../../utils/deviceService";
import { DeviceType } from "../../../models/constants/deviceType";
import userDeviceStore from "../../../store/device.store";

interface UserProps {
  activeTab?: string;
  transactionTab?: string;
}

export function User({
  activeTab: initialTab,
  transactionTab: initialTransactionTab,
}: UserProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(initialTab || "profile");

  const deviceType = userDeviceStore((state) => state.deviceType);

  useEffect(() => {
    if (initialTab) {
      setActiveTab(initialTab);
    }
  }, [initialTab, location.pathname]);


  const onTabChange = (tab: string) => {
    navigate(`/${tab}`);
    setActiveTab(tab);
  };

  let content = null;
  switch (activeTab) {
    case "profile":
      content = <UserProfilePage />;
      break;

    case "deposit":
      content = <Deposit />;
      break;
    case "withdrawal":
      content = <Withdraw />;
      break;
    case "wallethistory":
      content = <WalletHistory />;
      break;
    case "transactions":
      content = <Transactions currentTab={initialTransactionTab} />;
      break;
    case "responsible-gaming":
      content = <ResponsibleGaming />;
      break;
    case "verification":
      content = <Verification />;
      break;
    case "inbox":
      content = <InboxList />;
      break;
    case "bonus":
      content = <Bonus />;
      break;
    default:
      content = <div>No content found</div>;
      break;
  }

  const DEVICETYPE_STYLE: Record<string, string> = {
    [DeviceType.Mobile]: "",
    [DeviceType.Tablet]: "px-4",
    [DeviceType.Web]: "max-w-[90%] mx-auto",
  };

  return (
    <div>
      <UserTabs activeTab={activeTab} onTabChange={onTabChange} />
      <div className={`mt-10 ${DEVICETYPE_STYLE[deviceType]}`}>{content}</div>
    </div>
  );
}
